<template>
  <b-container class="custom-container p-0">
    <b-navbar type="dark" variant="white" class="center-screen p-0">
      <b-navbar-nav class="w-100">
        <b-nav-form>
          <div
            class="nav-search-container d-flex w-100 justify-content-between"
          >
            <div>
              <b-nav-item-dropdown
                id="my-nav-dropdown"
                block
                no-caret
                link
                left
              >
                <template v-slot:button-content>
                  <b-form-input
                    v-model="categoryLabel"
                    class="filter-input pl-4"
                  ></b-form-input>
                  <b-img
                    class="append-icon"
                    :src="require('@/assets/icons/chevron-secondary.svg')"
                  ></b-img>
                </template>

                <b-dropdown-item @click="filterCategory(null)"
                  >All categories</b-dropdown-item
                >
                <b-dropdown-item
                  v-for="category in categories"
                  :key="category.id"
                  @click="filterCategory(category)"
                  >{{ category.label }}</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </div>

            <div class="vertical mx-2 my-4"></div>

            <div class="d-flex" style="width: 480px">
              <b-form-input
                v-model="filters.search"
                placeholder="Search"
                class="search-input w-100 my-2"
                type="text"
                @input="goSearch"
              ></b-form-input>
            </div>

            <div class="vertical mx-2 my-4"></div>

            <div class="w-25">
              <place-autocomplete
                v-model="location"
                placeholder="Location"
                name="location"
                :api-key="$env.placesApiKey"
                :input-state="null"
                :input-error="null"
                input-class="search-input ellipsis w-100 my-2"
                :prepend-icon="true"
                @select="filterLocation"
              ></place-autocomplete>
            </div>

            <div class="vertical mx-2 my-4"></div>

            <div class="w-10">
              <b-nav-item-dropdown
                id="my-nav-dropdown"
                block
                no-caret
                link
                left
              >
                <template v-slot:button-content>
                  <b-form-input
                    v-model="distanceLabel"
                    class="filter-input w-100 px-0"
                  ></b-form-input>
                  <b-img
                    class="append-icon mr-2"
                    :src="require('@/assets/icons/chevron-secondary.svg')"
                  ></b-img>
                </template>

                <b-dropdown-item
                  v-for="distance in distances"
                  :key="distance.id"
                  @click="filterDistance(distance)"
                  >{{ distance.text }}</b-dropdown-item
                >
              </b-nav-item-dropdown>
            </div>

            <div>
              <b-button variant="primary" class="rounded-0">
                <b-icon scale="1.5" icon="search" aria-hidden="true"></b-icon>
              </b-button>
            </div>
          </div>
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PlaceAutocomplete from '@/components/autocomplete/PlaceAutocomplete'
import { findIndex } from 'lodash'
import debounce from 'lodash/debounce'

export default {
  components: {
    PlaceAutocomplete
  },

  data() {
    return {
      selected: null,
      distances: [
        { value: 1, text: '+1km' },
        { value: 5, text: '+5km' },
        { value: 10, text: '+10km' },
        { value: 20, text: '+20km' },
        { value: 50, text: '+50km' }
      ],
      distanceLabel: '+1km',
      categoryLabel: 'All Categories',
      location: '',
      coordinates: {
        lat: null,
        lng: null
      },
      filters: {
        category_id: null,
        search: null,
        within_distance_to: null
      }
    }
  },

  computed: {
    ...mapState({
      categories: state => state.category.list
    })
  },

  methods: {
    ...mapActions({
      getCategories: 'category/getCategories'
    }),

    getDistanceFilter(d) {
      return `${this.coordinates.lat},${this.coordinates.lng},${d * 1000}`
    },

    filterCategory(category) {
      this.categoryLabel = category ? category.label : 'All Categories'
      this.filters.category_id = category ? category.id : null

      this.$root.$emit('filterFeeds', this.filters)
    },

    goSearch: debounce(function() {
      this.filterSearch()
    }, 500),

    filterSearch() {
      this.$root.$emit('filterFeeds', this.filters)
    },

    filterLocation(coordinates) {
      if (coordinates) {
        const index = findIndex(this.distances, { text: this.distanceLabel })
        this.coordinates.lat = coordinates.lat
        this.coordinates.lng = coordinates.lng
        this.filters.within_distance_to = this.getDistanceFilter(
          this.distances[index].value
        )
      } else {
        this.filters.within_distance_to = null
      }

      this.$root.$emit('filterFeeds', this.filters)
    },

    filterDistance(distance) {
      this.distanceLabel = distance.text

      if (this.coordinates.lat && this.coordinates.lng) {
        this.filters.within_distance_to = this.getDistanceFilter(distance.value)
      } else {
        this.filters.within_distance_to = null
      }

      this.$root.$emit('filterFeeds', this.filters)
    }
  },

  created() {
    this.getCategories()
  }
}
</script>

<style lang="scss" scoped>
input {
  border-color: white;
  height: 72px;

  &:hover,
  &:focus {
    border-color: white;
  }
}
.append-icon {
  top: 32px;
  right: 8px;
}
.center-screen {
  min-height: auto;
  margin-top: -45px;
  box-shadow: 0px 0px 20px #00000029;
}
.vertical {
  border-left: 1px solid #00000029;
}
.btn {
  height: 88px;
}
.filter-input {
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-input {
  &:focus::placeholder {
    opacity: 0.3;
  }

  &::placeholder {
    color: black;
    opacity: 0.6;
    font-weight: bold;
    font-size: 1.1rem;
  }
}
.nav-search-container {
  max-height: 88px;
}
</style>
